import React, { useEffect, useState } from 'react'
import "../../assets/style/eegisterProvider.css"
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';
import components from '../../components';
import { Link,Outlet,useNavigate, useLocation, useParams } from 'react-router-dom';
import ApiCall from '../../utils/Api';
import PermissionsDetailTable from '../../components/Table/PermissionsDetailTable';
const PermissionsDetail = () => {
  
  const {id}=useParams()
  console.log("🚀 ~ PermissionsDetail ~ id:", id)
  const navigate = useNavigate();
  const location = useLocation();
  const[data,setdata]=useState()
  const[updateCount,setupdateCount]=useState(0)

  const getAllProviderDataByAdmin=async()=>{
    try {
console.log("================================================================>>>>CHeck");
      const data=await ApiCall.SECURE_API.get(`/provider/getProviderByID/${id}`)
      console.log("🚀 ~ getAllProviderDataByAdmin================= ~ data:", data)
      
      setdata(data.data.data)
   
    } catch (error) {
      console.log("🚀 ~ getAllProviderDataByAdmin ~ error:", error)
      
    }
  }
  console.log('location', location)
  useEffect(()=>{

    getAllProviderDataByAdmin()
  },[id,updateCount])
  const goBack = () => {
    navigate(-1);
  }
  return (
    <div style={{width:"100%",backgroundColor:"#F3F4F8"}}>
    <span className='RegisterProviderText'>
  <div style={{display:"flex",justifyContent:"space-between"}}>
  <span style={{paddingLeft:20}}>      <Button variant="contained"  onClick={goBack} style={{ marginRight: "20px",backgroundColor:"black" }}>
         {"< Back"}
        </Button>Permissions Detail</span> 
  {/* <Button onClick={()=>{
   navigate('/admin-panel/CheckProviderDetail/RegisterNewDataProvider');
  }}  variant="contained">Register New Data Provider</Button>  */}
   </div>     


    </span>
           <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"space-around",width:"100%"}}>
                           {/* <div style={{width:"95%",padding:27}} className='ProviderTitle'>
                               <div style={{display:"flex",flexDirection:"column",justifyContent:"space-evenly"}}>
                                   <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                                       <span style={{width:"100%", fontFamily: 'Manrope, sans-serif'}}>Provider Address</span>
                                   </div>
                                       <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginTop:10}}>
                                       <TextField style={{width:"100%"}} id="outlined-basic" label="Enter Provider Address" variant="outlined" />
                                       <div >
                                       <Button style={{paddingLeft:25,paddingRight:25,paddingTop:10,paddingBottom:10,marginLeft:10}} variant="contained">Check</Button>    
                                       </div>
                                       </div>
                               </div>
                           </div> */}
                           <div style={{width:"98%",marginTop:40}}>
                               <PermissionsDetailTable  data={data} setupdateCount={setupdateCount} updateCount={updateCount} id={id}/>    
                           </div>  
                           
           </div>
        
</div>
  )
}

export default PermissionsDetail